export const Tooltip = ({ data }) => {
  return (
    <span className="app-ai-quote-tooltip" tabIndex={0}>
      <span className="app-ai-quote-tooltip-text">{data}</span>
    </span>
  );
};
